import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";
import tableData from "DBTables/users.json"
import * as ajax from "helpers/ajax";

export default class Personale extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: []
        };
    }

    sendMail = (data) => {

        var text = "";

        text = "<img src='https://www.arinet.cloud/static/media/logo-arinet.834fb893123fa68c0a6e.png' width='250'>";
        text += "<br><p>Benvenuto/a  " + data.username + "</p>";
        text += "<p>In questa email trovi i dati di accesso al tuo account <a href='https://www.arinet.cloud'>Arinet</a></p><br><br>";
        text += "<p><b>email:</b> " + data.email + "<br>";
        text += "<b>password:</b> " + data.password + "</p>";

        var mailData = {
            from: "register@arinet.cloud",
            to: data.email,
            subject: "Benvenuto in Arinet",
            text: text
        };

        let formdata = { data: { mailData } }
        ajax.ajaxPostStrapi("email/", mailData, this.mailCallback)


    }

 
    mailCallback = (res) => {
    }


    render() {
        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    text={"Gestione account"}
                    icon={"person"}
                />
                <MDBox>
                    <MyDataTable
                        tableData={tableData}
                        edit={true}
                        delete={true}
                        add={true}
                        newRawData={(data) => { this.sendMail(data)}}
                        icon={"Personale"}
                    />
                </MDBox>

            </DashboardLayout>
        )
    }
}


